import React from "react";
import Select from "react-select";
import { Col, Label, Row } from "reactstrap";
import { BASE_URL, ERROR_RCTI_STATUS_ID } from "../../constants";
import {
  displayAddressFormater,
  displayDateFormater,
  getPrimaryOrSecondaryAddress,
  mustBeArray,
} from "../../utils/lib";
import { Link } from "react-router-dom";

/**
 * @typedef MYOBBasicDetailProps
 * @property {{
 *  rctiNumber: number,
 *  dateCreated: string,
 *  clientID: number,
 *  totalRebateAmount: number,
 *  totalRebateAmountExcGst: number,
 *  gstAmount: number,
 *  exportStatusID: number,
 *  exportErrorMessage: string,
 *  externalID: string,
 *  dateCreated: string,
 *  createdByUserId: string,
 *  dateModified: string,
 *  updatedByUserId: string,
 *  payToClient: boolean,
 *  exportStatusName: string,
 *  clientName: string,
 *  clientAbn: string,
 *  clientErrorMessage: string,
 *  supplierErrorMessage: string,
 *  rebateRctiLines: any[],
 *  clientAddresses: any[],
 *  ClientCommunications: any[],
 *  locationAddresses: any[],
 *  locationCommunications: any[]
 * }} details
 * @property {(value: any) => void} handleRCTIStatusChange
 * @property {boolean=} editMode
 * @property {number} rctiStatus
 * @property {{
 *  id: number,
 *  uniqueCode: string,
 *  name: string
 * }[]} rctiStatusOptions
 * 
 * @param {MYOBBasicDetailProps} props
 * @returns
 */
const MYOBBasicDetail = ({
  details,
  handleRCTIStatusChange = (v) => {},
  rctiStatus,
  rctiStatusOptions = [],
  editMode = false,
}) => {
  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={8} lg={6}>
          <Row className="align-items-center mb-h mt-2">
            <Col sm={4} md={3}>
              <Label className="mt-h">Invoice No</Label>
            </Col>
            <Col sm={8} md={9}>
              {details.invoiceNumber}
            </Col>
          </Row>
          <Row className="align-items-center mb-h">
            <Col sm={4} md={3}>
              <Label className="mt-h">Invoice Date</Label>
            </Col>
            <Col sm={8} md={9}>
              {displayDateFormater({
                value: details.invoiceDate,
              })}
            </Col>
          </Row>
          <Row className="align-items-center mb-h">
            <Col sm={4} md={3}>
              <Label className="mt-h">Invoice Name</Label>
            </Col>
            <Col sm={8} md={9}>
              <Link
                target="_blank"
                to={`${BASE_URL}/manage/clients/${
                  details.clientId
                }`}
              >
                {" "}
                {details.clientName}
              </Link>
            </Col>
          </Row>
          <Row className="align-items-center mb-h">
            <Col sm={4} md={3}>
              <Label className="mt-h">Billing Address</Label>
            </Col>
            <Col sm={8} md={9}>
              {details.billingAddress}
            </Col>
          </Row>
          <Row className="align-items-center mb-1 ">
            <Col sm={4} md={3}>
              <Label for="rctiStatus" className="mt-h">
                Export Status
              </Label>
            </Col>
            <Col sm={8} md={9}>
              {!editMode ? (
                details.exportStatusName
              ) : (
                <Select
                  defaultValue={1}
                  name="statusID"
                  value={rctiStatus}
                  multi={false}
                  clearable={false}
                  simpleValue={true}
                  options={mustBeArray(rctiStatusOptions)}
                  onChange={handleRCTIStatusChange}
                  valueKey="id"
                  labelKey="name"
                />
              )}
            </Col>
          </Row>
          {details &&
            details.hasExportErrors && (
              <React.Fragment>
                {details.exportDiagnostics && (
                  <Row className="align-items-center mb-h text-danger">
                    <Col sm={4} md={3}>
                      <Label for="rctiStatus" className="mt-h">
                        Export Error
                      </Label>
                    </Col>
                    <Col sm={8} md={9}>
                      {details.exportDiagnostics}
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default MYOBBasicDetail;
